import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppContext } from 'Context/GlobalContext/AppContext';
import App from 'App';
import './global.scss';
import './responsivity.scss';

const root = createRoot(document.getElementById('root'));
root.render(<React.StrictMode>
    <AppContext>
      <App />
    </AppContext>
  </React.StrictMode>);
